// EMBA E118 職業參訪歷程 — 真實資料
// 新增參訪時：(1) 在這加一筆；(2) 把 id 加到 worker/src/index.ts 的 ALLOWED_VISIT_IDS

export const VISITS = [
  {
    id: "otherworld-castle",
    date: "2026-05-03",
    dateLabel: "2026.05.03",
    dateShort: "05 / 03",
    year: "2026",
    company: "歐樂沃築夢城堡 OTHERWORLD",
    companyShort: "歐樂沃築夢城堡",
    location: "嘉義縣大林鎮",
    address: "嘉義縣大林鎮大埔美園區九路 18 號",
    industries: ["巧克力觀光工廠", "Bean to Bar", "主題園區"],
    cover: "otherworld",
    summary:
      "歐樂沃築夢城堡的故事，要從一片甘蔗園說起。創辦人毛榮海董事長從小在大埔美的台糖蔗園裡長大，後來成為打造劍湖山海盜村、上海迪士尼、北京環球度假區的「城堡大師」。2008 年嘉義縣政府為大埔美招商時，他立下心願：「有朝一日要在故鄉買地蓋城堡。」從一張草圖到 18 座尖塔，從預估 2 億到實際投入 10 億，前後十年築夢——城堡最高的塔貼上 2 萬 9000 片金箔，剛好是大林鎮人口數，是他向家鄉的致敬。「我想告訴大家，台灣人也會蓋城堡。」毛帥學長說。「沒有歡樂，做出來的就不會好看；有歡樂，你所做的每一件事情，就是富有生命跟快樂的元素。」這句從上海迪士尼帶回來的話，成了歐樂沃的精神支柱。",
    highlights: [
      "毛帥學長介紹分享",
      "瑪雅物語區 Bean to Bar 巧克力故事導覽",
      "築夢城堡 1F–2F 主場參觀（5 層樓主建築）",
      "O Café 茶點交流與經營理念分享",
      "築夢小鎮歐風建築與動線觀察",
    ],
    host: "歐樂沃築夢城堡 - 毛帥學長",
    schedule: "13:00–17:00",
    website: "https://www.otherworld.com.tw/",
    // 2026-07-28 改指向秘書處帳號（ncku.emba.e118）「活動歷程照片」下的副本。
    // 此資料夾單獨設為「知道連結的任何人 - 檢視者」，與母資料夾的「限制」刻意不一致——
    // Drive 會提示權限與上層不同，勿按「還原繼承」，否則 API 讀不到縮圖、相簿會安靜變空白。
    driveFolderId: "1nkTNdwbJ-lMucLNL3-soeYkWRH2GP31n",
  },
];

export const VISIT_BY_ID = Object.fromEntries(VISITS.map((v) => [v.id, v]));
